import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { fonts } from '../../Styles';

export const TranscriptRequestSuccessScreen = () => {
  return (
    <View style={styles.container} accessible={true}>
      <Text style={styles.header}>THANK YOU!</Text>
      <Text style={styles.paragraph}>
        Your request has been submitted. As a reminder, request can take up to 5 business days to be sent out.
      </Text>
      <Text style={styles.paragraph}>If you have any questions, please email:</Text>
      <Text style={styles.header}>transcripts@mail.mnohs.org</Text>
      <Text style={styles.paragraph}>(we have sent you a confirmation email)</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: '35%',
    flex: 1,
    width: '100%',
  },
  header: {
    ...fonts.header1,
    marginVertical: '5%',
  },
  paragraph: {
    ...fonts.paragraph,
    marginTop: '5%',
  },
});
